document.querySelectorAll('div.switch, div.checkbox').forEach(e => {
    let name = e.dataset.name;
    let value = +e.dataset.value;
    let input = document.createElement('input');
    input.type = 'number';
    input.name = name;
    input.value = value;
    input.defaultValue = value;
    input.addClass('trigger');
    if(value) e.addClass('active');

    e.innerHTML = '<div><span></span></div><span class="text">' + e.innerHTML + '</span>';
    e.appendChild(input);

    e.addEventListener('click', () => {
        e.toggleClass('active');
        const value = +e.hasClass('active');
        input.value = value;

        if('slideElement' in e.dataset) {
            const slideElement = document.getElementById(e.dataset.slideElement);
            value ? slideElement.slideDown() : slideElement.slideUp();
        }
    })

    input.addEventListener('change', () => {
        +input.value ? e.addClass('active') : e.removeClass('active');
        if('slideElement' in e.dataset) {
            const slideElement = document.getElementById(e.dataset.slideElement);
            value ? slideElement.slideDown() : slideElement.slideUp();
        }
    })
})